import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthPainelService {

  private apiUrl = `${environment.url_api}`;

  constructor(
    private http: HttpClient,
    private toastrService: ToastrService,
    private router: Router,
    private sessionService: SessionService
  ) { }

    login(email: string, senha: string): Observable<any> {
      return this.http.post<any>(`${this.apiUrl}v1/eventos/login-painel.php`, { "usuario": email,"senha": senha }).pipe(
        tap(response => {
          if (response && response.token) {
            this.sessionService.setPainelToken(response.token);
          }
        })
      );
    }

  logout(tokenVencido: boolean = false) {
    this.sessionService.clearPainelToken();

    if(!tokenVencido){
      this.toastrService.info('Usuário deslogado');
      this.redirecionarParaLogin();
    }else{
      this.toastrService.warning('Sessão expirada. Faça login novamente.');
    }
  }

  isLoggedIn(): boolean {
    return !!this.sessionService.getPainelToken();
  }

  recuperarToken(): string {
    return this.sessionService.getPainelToken();
  }

  deslogarClienteTokenInvalido(){
    this.logout(true);
    this.redirecionarParaLogin();
  }

  redirecionarParaLogin(){
    this.router.navigate(['painel/entrar'])
  }
}
